<style scoped>
.budget_bg {
	position: relative;
	height: 8px;
	background-color: #DADADA;
}

.budget_shade {
	position: absolute;
	top: 0px;
	width: 100%;
	left: 0px;
	height: 4px;
	background-color: #888888;
}

.budget_used {
	position: absolute;
	top: 0px;
	left: 0px;
	height: 8px;
	/* background-color: #00DD00; */
}
</style>

<template>
	<div class="budget_bg">
		<!-- <div class="budget_shade"></div> -->
		<div class="budget_used" :style="budget_used_style"></div>
	</div>
</template>

<script>
export default {
	props: {
		used: {
			type: Number,
			default: 0
		},
		color: {
			type: String,
			default: '#00DD00'
		},
		fullColor: {
			type: String,
			default: 'rgb(192, 165, 39)'
		}
	},
	computed: {
		budget_used_style: function() {
			let style="width: ";

			// need to add colors...
			if (this.used < 70) {
				style += this.used + `%; background-color: ${this.color}`;
			} else if (this.used <= 100) {
				style += this.used +`%; background-color: ${this.fullColor};`;
			} else {
				style += "100%; background-color: rgb(204, 26, 12);";				
			}

			return style;
		},		
	}
}
</script>
